import { render, staticRenderFns } from "./message-box.vue?vue&type=template&id=0046ab0c&scoped=true&"
import script from "./message-box.vue?vue&type=script&lang=js&"
export * from "./message-box.vue?vue&type=script&lang=js&"
import style0 from "./message-box.vue?vue&type=style&index=0&id=0046ab0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0046ab0c",
  null
  
)

export default component.exports